import RenderIf from "common/components/RenderIf";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "common/components/ui/Accordion";
import { Tag } from "common/components/ui/Tag";
import { LEADS_FACETS } from "common/constants";
import type { LeadsSearchParams, SelectedFacetParam } from "common/types";

import { DRIP_FACET_KEYS } from "../../../../../constants";
import DripFacet from "./DripFacet";
import FavoriteFilter from "./FavoriteFilter";

interface FiltersProps {
  searchParams: LeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: Partial<LeadsSearchParams<SelectedFacetParam>>,
  ) => void;
}

export default function MobileFilters({
  searchParams,
  setSearchParams,
}: FiltersProps) {
  return (
    <Accordion type="multiple" className="mb-4">
      {DRIP_FACET_KEYS.map((facetKey) => {
        const { icon: Icon, label } = LEADS_FACETS[facetKey];
        const searchKey = facetKey === "schools" ? "education" : facetKey;

        const selectedFiltersCount = searchParams[searchKey].length;

        return (
          <AccordionItem value={facetKey} key={facetKey}>
            <AccordionTrigger className="h-14">
              <Icon weight="fill" size={20} />
              <span className="line-clamp-1 break-all">{label}</span>

              <RenderIf condition={!!selectedFiltersCount}>
                <Tag variant="primary-black">{selectedFiltersCount}</Tag>
              </RenderIf>
            </AccordionTrigger>
            <AccordionContent>
              <DripFacet
                facetKey={facetKey}
                searchKey={searchKey}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
              />
            </AccordionContent>
          </AccordionItem>
        );
      })}
      <FavoriteFilter
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    </Accordion>
  );
}
